import { css } from 'emotion';

export namespace styles {
  const TILE_WIDTH = 42;

  export const calendarContainer = css({ marginTop: 25 });

  export const monthContainerRules = css({
    height: 180
  });

  export const dateRules = (isSelected: boolean) => {
    const buttonHoverState = isSelected
      ? {
          color: 'white',
          backgroundColor: 'rgb(189,189,189)',
          ':hover': {
            backgroundColor: 'rgb(97,97,97)'
          }
        }
      : {
          ':hover': {
            backgroundColor: 'rgb(250,250,250)'
          }
        };

    return css({
      width: TILE_WIDTH,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 12,
      fontWeight: 600,
      ' button': {
        cursor: 'pointer',
        userSelect: 'none',
        outline: 'none',
        borderRadius: '50%',
        height: 30,
        width: 30,
        lineHeight: '32px',
        boxShadow: 'none',
        border: 'none',
        backgroundColor: 'transparent',
        padding: 0,
        transition: 'background-color .4s cubic-bezier(.25, .8, .25, 1), color .4s cubic-bezier(.25, .8, .25, 1)',

        ...buttonHoverState
      }
    });
  };

  export const weekdayContainerRules = css({
    display: 'flex',
    textAlign: 'center'
  });

  export const week = css({ display: 'flex' });

  export const weekdayRules = css({
    width: TILE_WIDTH,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'rgba(0, 0, 0, 0.87)',
    userSelect: 'none',
    opacity: 0.4,
    fontWeight: 500
  });
}
